import * as React from "react";
import { Link } from "gatsby";

import logo from "../img/logo.svg";
import facebook from "../img/social/facebook.svg";
import twitter from "../img/social/twitter.svg";
import linkedin from "../img/social/linkedin.svg";
import github from "../img/social/github.svg";
import pinterest from "../img/social/pinterest.svg";
import SiteVisitorCount from "./SiteVisitorCount";

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container footer-content has-background-black has-text-white-ter">
            <div className="footer-brand">
              <Link to="/">
                <img
                  src={logo}
                  alt="Predinfer"
                  style={{ width: "10em", height: "2em" }}
                />
              </Link>
            </div>
            <div className="footer-social">
              <a
                title="linkedin"
                href="https://www.linkedin.com/company/predinfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={linkedin}
                  alt="linkedin"
                  style={{ width: "1em", height: "1em" }}
                />
              </a>
              <a
                title="twitter"
                href="https://x.com/predinfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="fas fa-lg"
                  src={twitter}
                  alt="Twitter"
                  style={{ width: "1em", height: "1em" }}
                />
              </a>
              <a
                title="facebook"
                href="https://facebook.com/predinfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={facebook}
                  alt="Facebook"
                  style={{ width: "1em", height: "1em" }}
                />
              </a>
              <a
                title="pinterest"
                href="https://www.pinterest.com/predinfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={pinterest}
                  alt="pinterest"
                  style={{ width: "1em", height: "1em" }}
                />
              </a>
              <a
                title="github"
                href="https://github.com/predinfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={github}
                  alt="github"
                  style={{ width: "1em", height: "1em" }}
                />
              </a>
            </div>
            <nav aria-label="Footer navigation">
              <ul className="footer-links">
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/tags">Tags</Link>
                </li>
                <li>
                  <Link to="/newsletter">Newsletter</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
            <SiteVisitorCount />
            <div className="footer-copyright">
              © 2023-{new Date().getFullYear()} Predinfer
            </div>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
